import { Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const HeaderCellStyles = StyleSheet.create({
  symbolCell: {
    flexShrink: 0,
    minWidth: Spacing.S14,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  symbolCellText: {
    textAlign: 'left',
    width: '100%',
  },
  mainGroupCell: {
    flexGrow: 1,
    flexBasis: 0,
  },
  subSectionCell: {
    flexGrow: 1,
    flexBasis: 0,
    minWidth: 0,
  },
  columnLabelsCell: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: Spacing.S8,
  },
  columnLabelSlot: {
    minWidth: 56,
    alignItems: 'flex-end',
  },
})
